import { render, staticRenderFns } from "./SsoPage.vue?vue&type=template&id=ebcf7056"
import script from "./SsoPage.vue?vue&type=script&lang=js"
export * from "./SsoPage.vue?vue&type=script&lang=js"
import style0 from "./SsoPage.vue?vue&type=style&index=0&id=ebcf7056&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports